import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DecompModo } from 'types/Relatorios/Decomp';

export interface DataAnalisada {
  mes: number;
  ano: number;
  dia: number;
}

export interface RelatoriosDecompState {
  mes: number;
  ano: number;
  dia: number;
  cenario: string;
  modo: DecompModo;
}

const now = new Date();
const initialState: RelatoriosDecompState = {
  mes: now.getMonth() + 1,
  ano: now.getFullYear(),
  dia: now.getDate(),
  cenario: '',
  modo: 'preliminar',
};

const relatoriosDecompSlice = createSlice({
  name: 'relatoriosDecomp',
  initialState,
  reducers: {
    setDataAnalisada: (state, action: PayloadAction<DataAnalisada>) => {
      state.mes = action.payload.mes;
      state.ano = action.payload.ano;
      state.dia = action.payload.dia;
    },
    setCenario: (state, action: PayloadAction<string>) => { state.cenario = action.payload; },
    setModo: (state, action: PayloadAction<DecompModo>) => { state.modo = action.payload; },
    reset: () => initialState,
  },
});

export const {
  setDataAnalisada, setCenario, setModo, reset,
} = relatoriosDecompSlice.actions;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fatiaDecomp = (state: any): RelatoriosDecompState => state.relatoriosDecomp;
/**
 * Memorizado: devolve o mesmo objeto enquanto a data não muda. O `useSelector` compara por
 * referência, e um objeto novo a cada chamada desenharia de novo, a cada ação do Redux (RTK Query,
 * polling), toda tela que lê a data.
 */
export const selectDecompDataAnalisada = createSelector(
  [
    (state: unknown) => fatiaDecomp(state).mes,
    (state: unknown) => fatiaDecomp(state).ano,
    (state: unknown) => fatiaDecomp(state).dia,
  ],
  (mes, ano, dia): DataAnalisada => ({ mes, ano, dia }),
);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectDecompCenario = (state: any): string => state.relatoriosDecomp.cenario;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectDecompModo = (state: any): DecompModo => state.relatoriosDecomp.modo;

export default relatoriosDecompSlice.reducer;
